// アンカースクロール
$(function () {
    const getHeaderHeight = function () {
        return ($('.header-p').outerHeight() || 0) + 20;
    };

    const scrollToHash = function (hash) {
        const $target = $(hash);

        if (!$target.length) return;

        const headerHeight = getHeaderHeight();
        const targetPosition = $target.offset().top - headerHeight;

        $('html, body').animate(
        {
            scrollTop: targetPosition,
        },
        500
        );
    };

    $('a[href^="#"]').on('click', function (e) {
        const href = $(this).attr('href');

        if (!href || href === '#') return;

        if (!$(href).length) return;

        e.preventDefault();

        scrollToHash(href);
    });

    if (window.location.hash) {
        setTimeout(function () {
        scrollToHash(window.location.hash);
        }, 100);
    }
});